/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ connector: NonNullable<unknown> }} Agent_Templates_Connect_NamedInputs */



/**
* | output |
* | --- |
* | "Connect {connector}" |
*
* @param {Agent_Templates_Connect_NamedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_templates_connect_named = /** @type {((inputs: Agent_Templates_Connect_NamedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Templates_Connect_NamedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.connector} verbinden`)
	return /** @type {LocalizedString} */ (`Connect ${i?.connector}`)
});